import Promise from 'promise-polyfill';

/**
 * ScaleMedia
 *
 * The below functions assume the container will dictate the minimum, required
 * resolution when scaling media. The .js-scale-media-container class should be
 * added to a parent element of .js-scale-media for this reason. A fallback
 * 'crop' class can be added to the HTML for when JavaScript is turned off.
 */
export default class scaleMedia {
  constructor(el) {
    this.el = el;
    this.el.classList.add('js-scale-media');
    this.mediaType = this.el.tagName.toLowerCase();
    this.findAncestor(this.el, 'js-scale-media-container');
    this.resize();
  }

  findAncestor(el, className) {
    let parent = el;
    while (!parent.classList.contains(className)) {
      parent = parent.parentElement;
    }
    this.container = parent;
  }

  resize() {
    const { el } = this;
    const resizeFn = this.resize.bind(this);
    const containerWidth = this.container.offsetWidth;
    const containerHeight = this.container.offsetHeight;
    let mediaWidth = 0;
    let mediaHeight = 0;
    let elPromise = null;

    // Get the natural dimensions.
    switch (this.mediaType) {
      case 'img':
        mediaWidth = el.naturalWidth;
        mediaHeight = el.naturalHeight;
        break;
      case 'video':
        mediaWidth = el.videoWidth;
        mediaHeight = el.videoHeight;
        break;
      default:
        // Only images and video elements are allowed.
        return;
    }

    // Try again once the media is loaded.
    if (mediaWidth <= 0 || mediaHeight <= 0) {
      if (this.mediaType === 'img') {
        elPromise = new Promise((resolve, reject) => {
          el.onload = () => resolve({ status: 'ok' });
          el.onerror = () => reject({ status: 'error' });
        });
      } else {
        elPromise = new Promise((resolve, reject) => {
          el.onloadeddata = () => resolve({ status: 'ok' });
          el.onerror = () => reject({ status: 'error' });
        });
      }

      elPromise
        .then(() => {
          resizeFn();
        })
        .catch(() => {
          // Fallback to using the container dimensions.
          if (containerWidth > containerHeight) {
            this.cropHeight();
          } else {
            this.cropWidth();
          }
        });
      return;
    }

    // Add the appropriate media scaling class.
    if (mediaWidth * containerHeight / mediaHeight < containerWidth) {
      this.cropHeight();
    } else {
      this.cropWidth();
    }
  }

  cropHeight() {
    this.el.classList.remove('js-scale-media--crop-width');
    this.el.classList.add('js-scale-media--crop-height');
  }

  cropWidth() {
    this.el.classList.remove('js-scale-media--crop-height');
    this.el.classList.add('js-scale-media--crop-width');
  }
}



// WEBPACK FOOTER //
// ./screens/App/components/ScalableMedia/ScaleMedia.js